<template>
  <div id="app" style="max-width: 100vw; overflow-x: hidden;">
    <NavCustom></NavCustom>
    <div id="fb-root"></div>
    <router-view/>
    <FooterCustom></FooterCustom>
  </div>
</template>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

$primary: #000000;
$primary-light: findLightColor($primary);
$primary-dark: findDarkColor($primary);
$primary-invert: findColorInvert($primary);

$blue: #293064;
$blue-light: findLightColor($blue);
$blue-dark: findDarkColor($blue);
$blue-invert: findColorInvert($blue);

$info: $blue;
$info-light: findLightColor($info);
$info-dark: findDarkColor($info);
$info-invert: findColorInvert($info);

$gold: #FFD41A;
$gold-light: findLightColor($gold);
$gold-dark: findDarkColor($gold);
$gold-invert: findColorInvert($gold);

$yellow: $gold;
$yellow-light: findLightColor($yellow);
$yellow-dark: findDarkColor($yellow);
$yellow-invert: findColorInvert($yellow);

$green: #96E8BC;
$green-light: findLightColor($green);
$green-dark: findDarkColor($green);
$green-invert: findColorInvert($green);

$link: $blue;
$link-invert: findColorInvert($link);
$link-dark: findDarkColor($link);
$link-light: findLightColor($link);
$link-focus-border: $link;

$white: #ffffff;
$white-invert: findColorInvert($white);
$white-dark: findDarkColor($white);
$white-light: findLightColor($white);

$off-white: #fffbf2;
$off-white-invert: findColorInvert($off-white);
$off-white-dark: findDarkColor($off-white);
$off-white-light: findLightColor($off-white);

$ghost-white: #fafaff;
$ghost-white-invert: findColorInvert($ghost-white);
$ghost-white-dark: findDarkColor($ghost-white);
$ghost-white-light: findLightColor($ghost-white);

$light-blue: #2CB3F3;
$light-blue-invert: findColorInvert($light-blue);
$light-blue-dark: findDarkColor($light-blue);
$light-blue-light: findLightColor($light-blue);

$custom-colors: null !default;
$custom-shades: null !default;

$colors: mergeColorMaps(
  (
    "primary": (
      $primary,
      $primary-invert,
      $primary-light,
      $primary-dark,
    ),
    "info": (
      $info,
      $info-invert,
      $info-light,
      $info-dark
    ),
    "blue": (
      $blue,
      $blue-invert,
      $blue-light,
      $blue-dark
    ),
    "gold": (
      $gold,
      $gold-invert,
      $gold-light,
      $gold-dark,
    ),
    "yellow": (
      $yellow,
      $yellow-invert,
      $yellow-light,
      $yellow-dark,
    ),
    "green": (
      $green,
      $green-invert,
      $green-light,
      $green-dark,
    ),
    "link": (
      $link,
      $link-invert,
      $link-light,
      $link-dark,
    ),
    "white": (
        $white,
        $white-invert,
        $white-light,
        $white-dark,
    ),
    "off-white": (
        $off-white,
        $off-white-invert,
        $off-white-light,
        $off-white-dark,
    ),
    "ghost-white": (
        $ghost-white,
        $ghost-white-invert,
        $ghost-white-light,
        $ghost-white-dark,
    ),
    "light-blue": (
      $light-blue,
      $light-blue-invert,
      $light-blue-light,
      $light-blue-dark
    )
  ),
  $custom-colors
);

@import url('https://fonts.googleapis.com/css2?family=Inclusive+Sans:ital,wght@0,300..700;1,300..700&family=Space+Mono:wght@400;700&display=swap');

@font-face {
  font-family: Extenda;
  src: url("assets/extenda-50-mega.ttf");
}

@font-face {
  font-family: Extenda XS;
  src: url("assets/extenda-xs-40-hecto.ttf");
}

#app {
  font-family: 'Inclusive Sans', sans-serif !important;
}

.title {
  font-family: 'Extenda', sans-serif;
  text-transform: uppercase;
}

.heading {
  font-family: 'Extenda XS', sans-serif;
}

.heading-mono {
  font-family: "Space Mono", monospace;
  font-weight: 700;
  text-transform: uppercase;
}

.button, .tag {
  font-family: 'Space Mono', monospace !important;
  text-transform: uppercase;
}

nav.tabs {
  font-family: 'Space Mono', monospace !important;
  text-transform: uppercase;
}

$title-color: $primary;
$title-weight: 400;

.tag {
  font-size: 10px !important;
}

$navbar-item-img-max-height: 40px;

$tabs-link-focus-active-border-bottom-color: $primary;
$tabs-boxed-link-active-background-color: $yellow;
$tabs-link-active-color: $primary;

$box-radius: 0;
$input-radius: 0;
$tabs-boxed-link-radius: 0;
.button {border-radius: 0 !important;}

$skeleton-background: linear-gradient(90deg, $grey-light 25%, rgba($grey-light, 0.5) 50%, $grey-light 75%);

$footer-padding: 0;

@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>

<script>
import NavCustom from "./components/NavCustom";
import FooterCustom from "./components/FooterCustom";
export default {
  components: {FooterCustom, NavCustom}
}
</script>
